import type { AdvancedPipelineContext, AdvancedVSeed } from 'src/types'
import { execPipeline } from '../../pipeline'
import type { Builder } from './builder'
import { intl } from 'src/i18n'

export const buildAdvanced = (builder: Builder): AdvancedVSeed | null => {
  const start = typeof performance !== 'undefined' ? performance.now() : Date.now()
  const { chartType } = builder.vseed
  if (!chartType) {
    throw new Error('chartType is nil in buildAdvanced')
  }

  const BuilderCtor = builder.constructor as typeof Builder
  const pipeline = BuilderCtor.getAdvancedPipeline(chartType)
  if (!pipeline) {
    throw new Error(
      `please invoke registerAll or register ${chartType} before build, no advanced pipeline for chartType ${chartType}`,
    )
  }

  const context: AdvancedPipelineContext = {
    vseed: builder.vseed,
    customTheme: BuilderCtor.getThemeMap(),
  }
  if (builder.locale) {
    intl.setLocale(builder.locale)
  }

  try {
    const advancedVSeed = execPipeline<AdvancedVSeed, AdvancedPipelineContext>(pipeline, context)
    builder.advancedVSeed = advancedVSeed
    return advancedVSeed
  } catch (e) {
    throw new Error(`buildAdvanced error: ${(e as Error).message}`)
  } finally {
    const end = typeof performance !== 'undefined' ? performance.now() : Date.now()
    builder.performance['buildAdvanced'] = `${(end - start).toFixed(4)}ms`
  }
}
